module.exports = __webpack_public_path__ + "media/assets/icons/genius-af0d47a3352c48d5684dd904a67292de.svg";